import CustomBackButton from "@/components/custom/custom-back-button";
import CustomPagination from "@/components/custom/custom-pagination";
import CustomSearchInput from "@/components/custom/custom-search-input";
import { DataTable } from "@/components/custom/data-table";
import { useUsersOfCategory } from "@/hooks/use-user-of-category";
import { Box, Stack, styled, Typography, Skeleton } from "@mui/material";
import { useParams, useSearchParams } from "react-router-dom";
import { getUsersCategoryColumns } from "./_components/user-category-column";
import { useCategoryById } from "@/hooks/use-category-by-id";
import { useState } from "react";
import MoveCategoryDialog from "./_components/move-category-dialog";

const RootWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
}));

const Card = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 12,
  padding: theme.spacing(2.5),
  backgroundColor: theme.palette.background.paper,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const CategoryUsers = () => {
  const [searchParams] = useSearchParams();
  const searchValue = searchParams.get("search") || "";
  const currentPage = Number(searchParams.get("page") || 0);
  const pageSize = Number(searchParams.get("size") || 10);

  const { categoryId } = useParams();

  const queryParams = {
    page: currentPage,
    size: pageSize,
    search: searchValue,
  };

  const { data: category, isLoading: isCategoryLoading } = useCategoryById(
    categoryId,
    true,
  );

  const {
    data: users,
    isLoading,
    isError,
  } = useUsersOfCategory(category?.data?.id, !!category?.data?.id, queryParams);

  const [moveUser, setMoveUser] = useState(null);

  return (
    <RootWrapper>
      <Card>
        <Stack
          direction="row"
          spacing={3}
          alignItems="center"
          justifyContent="space-between"
        >
          <Box display="flex" alignItems="center" gap={1.5}>
            <CustomBackButton />
            {isCategoryLoading ? (
              <Skeleton
                variant="text"
                width={180}
                height={32}
                sx={{ borderRadius: 1 }}
              />
            ) : (
              <Typography fontWeight={500} fontSize={18}>
                {category?.data?.name} Users
              </Typography>
            )}
          </Box>
          <Stack direction="row" spacing={3}>
            <CustomSearchInput
              paramKey="search"
              placeholder="Search users..."
            />
          </Stack>
        </Stack>

        <DataTable
          columns={getUsersCategoryColumns((user) => setMoveUser(user))}
          data={users?.data?.data ?? []}
          isLoading={isLoading}
          isError={isError}
        />
        <CustomPagination
          total={users?.data?.totalCount ?? 0}
          perPageOptions={[5, 10, 20, 50, 100]}
        />
      </Card>

      <MoveCategoryDialog
        open={Boolean(moveUser)}
        onClose={() => setMoveUser(null)}
        user={moveUser}
      />
    </RootWrapper>
  );
};

export default CategoryUsers;
